export default __webpack_public_path__ + "static/media/brain-banner.67220566.jpg";